import { render, staticRenderFns } from "./comfirmMessage.vue?vue&type=template&id=92295f8a&scoped=true&lang=html"
import script from "./comfirmMessage.vue?vue&type=script&lang=js"
export * from "./comfirmMessage.vue?vue&type=script&lang=js"
import style0 from "./comfirmMessage.vue?vue&type=style&index=0&id=92295f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92295f8a",
  null
  
)

export default component.exports